/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: deviceSipProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Device SIP Profiles module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteDeviceSipProfile } from './api';

/**
 * Shared helpers for Device SIP Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Device SIP Profile in the form.
 * Pattern: /settings/technology/device-profile/new?duplicate={id}
 */
export const getDeviceSipProfileDuplicateUrl = (id: string | number): string =>
  `/settings/technology/device-profile/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Device SIP Profile id.
 */
export const navigateToDeviceSipProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getDeviceSipProfileDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Device SIP Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteDeviceSipProfile from './api' instead
 */
export const deleteDeviceSipProfileById = async (id: string | number): Promise<void> => {
  await deleteDeviceSipProfile(id);
};

